export class AutomatedElements {
  date :string = 'Date';
  entityName :string = 'Entity Name';
  addManagement :string  = 'Addresse - Management';
  addBoDir: string = 'Addresse - Board of directors';
  addShare :string = 'Addresse - Shareholders';
  yearEndCurr :string = 'Year end date (CY)';
  yearEndPrev :string = 'Year end date (PY)';
  note :string = 'Note X';
  clientCity :string = 'Client City';
  cityState :string = 'City,State'; //us
  cityProvince :string = 'City, Province';//ca
  addComplete :string = 'Complete address';
  postalCode :string = 'Postal Code';
  firstName :string = 'First Name';
  lastName :string = 'Last Name';
  engId :string = 'Engagement ID';
  balanceSheet :string = 'Balance Sheet';
  sire: string = 'Statement of income and Retained Earnings';
  sc: string = 'Statement of cashflow';
  scse: string = 'Statement of changes in stockholders equity';
  firmName: string = 'Firm Name';
  firmSignature: string = 'Firm Sign here';
  clientSignature: string = 'Client Signature';
  clientSignedDate: string = 'Client Signed Date';
  firmAddress: string = 'Firm Address';
  partnerName: string = 'Partner Name';
  streetAddress: string = 'Street Address';
  datePicker: string = 'Date Picker';
  engLetterDate: string = 'Engagement Letter Date';
}

export class RegExpModel {
  date : RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Date<\/span>/gi;
  entityName :RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Entity Name<\/span>/gi;
  addManagement :RegExp  = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Addresse - Management<\/span>/gi;
  addBoDir: RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Addresse - Board of directors<\/span>/gi;
  addShare :RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Addresse - Shareholders<\/span>/gi;
  yearEndCurr :RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Year end date \(CY\)<\/span>/gi;
  yearEndPrev :RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Year end date \(PY\)<\/span>/gi;
  note :RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Note X<\/span>/gi;
  clientCity :RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Client City<\/span>/gi;
  cityState :RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">City,State<\/span>/gi;    //us
  cityProvince :RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">City, Province<\/span>/gi; //ca
  addComplete :RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Complete address<\/span>/gi;
  balanceSheet :RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Balance Sheet<\/span>/gi;
  postalCode :RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Postal Code<\/span>/gi;
  firstName :RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">First Name<\/span>/gi;
  lastName :RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Last Name<\/span>/gi;
  scse : RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Statement of changes in stockholders equity<\/span>/gi; //us
  sc :RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Statement of cashflow<\/span>/gi; //us
  sire : RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Statement of income and Retained Earnings<\/span>/gi;
  firmName: RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Firm Name<\/span>/gi;
  firmSignature: RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Firm Signature<\/span>/gi;
  clientSignature: RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Client Signature<\/span>/gi;
  clientSignedDate: RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Client Signed Date<\/span>/gi;
  firmAddress: RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Firm address<\/span>/gi;
  partnerName: RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Partner Name<\/span>/gi;
  streetAddress: RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Street Address<\/span>/gi;
  datePicker: RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Date Picker<\/span>/gi;
  engLetterDate: RegExp = /<span class="auto-elements is-locked" style="background-color: #DDF0DF;">Engagement Letter Date<\/span>/gi;
}

export class ImageLetterModel {
  s3FilePath: string | null = '';
  s3ImagePath : string | null = '';
  imageId : number = 0;
  imageType : 'header' | 'footer' | 'sign';
  isSignedDate: any;
  signatureText?: string;
  signatureType?: 'draw' | 'upload' | 'text';
  alignmentvalue?: 'Left' | 'Center' | 'Right' | null;
  is_stretch_fit?: number;
  picture_alignment?: string;
  resizeJsonFilePath?: string;
  isStretchFit?: number;
  pictureAlignment?: string;
}

export class ElementsInputObj {
  engagementId: number;
  clientFirmId: number;
  loginId:number;
  firmHash: string;
}

export class ExportLetterModel {
  engtemplateId: number = 0;
  headerImage: string = '';
  footerImage: string = '';
  firmSignature: string = '';
  clientSignature: string = '';
  firmSignatureType: string = '';
  clientSignatureType: string = '';
  isClientSignature: boolean = false;
  exportContent: Array<any> = [];
  clientSignatureText: string = null;
  isHeaderStretch: boolean = false;
  headerAlignment: string = 'center';
  isFooterStretch: boolean = false;
  footerAlignment: string = 'center';
  isPdf: boolean;
  headerId?: string;
  footerId?: string;
  firmId?: string;
  footerName?: string;
  headerName?: string;
  headerPlacement: string;
  footerPlacement: string;
}

export class AddManagementLetterModel {
  firmTemplateId: number;
  templateName: string = '';
  engagementId: number;
  loginId: number;
  jsonFileName: string;
  jsonFilePath: string;
  subModuleId: number;
  masterTemplateId: number = 0;
  // sourceFileName: string;
  // sourceFilePath: string;
}

export const ImageClasses = {
  stretchFit: 'image-align-Stretch',
  stretchFitHeader: 'image-align-Stretch-header',
  stretchFitFooter: 'image-align-Stretch-footer',
  center: 'justify-content-center',
  left: 'justify-content-start',
  right: 'justify-content-end',
};

export class NavigateReportModel {
  reportId: string;
  reportFolderId: string;
  selectedMoveType: 'New' | 'Exist';
  isNavigate: boolean = false;
}

export class compArchiveModel {
  engagementId: number;
  statusId: number;
  statusName: string;
  completionType: string;
  reopenReason: string;
  completedArchiveId: number;
  daysToComplete: number;
}
